import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TablePagination",
  props: {
    offset: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1;
    },
    pageNumbers() {
      let pages = [];
      if (this.totalPages <= 5) {
        pages = _Array$from({
          length: this.totalPages
        }, (e, i) => i + 1);
      } else {
        pages = this.middlePages();
        pages.unshift(1);
        pages.push(this.totalPages);
      }
      return pages;
    },
    currentListLength() {
      const total = _parseInt(this.total);
      return this.offset + this.limit > total ? total - this.offset : this.limit;
    },
    previousButtonClass() {
      return this.currentPage === 1 ? "disabled" : "";
    },
    nextButtonClass() {
      return this.currentPage === this.totalPages || this.totalPages === 0 ? "disabled" : "";
    }
  },
  methods: {
    middlePages() {
      if (this.currentPage <= 3) {
        return [2, 3, 4];
      } else if (this.currentPage >= this.totalPages - 3) {
        return [this.totalPages - 3, this.totalPages - 2, this.totalPages - 1];
      } else {
        return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
      }
    },
    currentPageButtonClass(page) {
      return this.currentPage === page ? "current" : "";
    },
    showEllipsis(page, index) {
      if (page === this.totalPages) return false;
      return page + 1 !== this.pageNumbers[index + 1];
    },
    handlePageClick(page) {
      if (this.currentPage !== page) {
        const newOffset = (page - 1) * this.limit;
        this.$emit("page-change", {
          offset: newOffset,
          page
        });
      }
    },
    handleIncrementClick(change, page) {
      const newOffset = this.offset + change;
      this.$emit("page-change", {
        offset: newOffset,
        page
      });
    }
  }
});